import React from "react";
import arrowUpRight from "./icons/arrow-up-right.svg";
import checkBadge from "./icons/check-badge.svg";
import checkStage from "./icons/check-stage.svg";
import chevronRight from "./icons/chevron-right.svg";
import circleCheck from "./icons/circle-check.svg";
import circlePause from "./icons/circle-pause.svg";
import github from "./icons/github.svg";
import info from "./icons/info.svg";
import layers from "./icons/layers.svg";
import monitor from "./icons/monitor.svg";
import pauseBadge from "./icons/pause-badge.svg";
import pauseStage from "./icons/pause-stage.svg";
import rotateCcw from "./icons/rotate-ccw.svg";
import server from "./icons/server.svg";
import smartphone from "./icons/smartphone.svg";
import triangleAlert from "./icons/triangle-alert.svg";
import users from "./icons/users.svg";

/**
 * Figma icon assets for the health board.
 * Each file keeps the width and height exported from the design.
 * @type {Record<string, string>}
 */
export const healthIcons = {
  arrowUpRight,
  checkBadge,
  checkStage,
  chevronRight,
  circleCheck,
  circlePause,
  github,
  info,
  layers,
  monitor,
  pauseBadge,
  pauseStage,
  rotateCcw,
  server,
  smartphone,
  triangleAlert,
  users,
};

/**
 * Renders a health-board icon at its exported size.
 * @param {{ name: keyof typeof healthIcons }} props
 * @returns {JSX.Element}
 */
export function HealthIcon({ name }) {
  return <img src={healthIcons[name]} alt="" className="block shrink-0" />;
}
